module.exports = __webpack_public_path__ + "static/media/nps-image.c7af2750.jpeg";